import * as yup from 'yup';

export interface IAquaField {
  key: string;
  value: string | null;
  fieldId: number;
}

export const AquaFieldSchema = yup.object({
  key: yup.string().required(),
  value: yup.string().nullable(),
  fieldId: yup.number().required(),
});
